import AdbFilterButtonItem from './custom/filter-button-item';
import AdbFilterButtonGroup from './custom/filter-button-group';
import AdbFilterOperation from './custom/filter-item-operation';
import AdbFilterDrawer from './custom/filter-drawer';
import AdbFilterTag from './custom/filter-tag';
import AdbIcon from './base/adb-icon';
import AdbButton from './base/adb-button';
import AdbDialog from './base/adb-dialog';
import AdbDraggable from './base/adb-draggable';
import AdbFormItem from './base/adb-form-item';
import AdbImage from './base/adb-image';
import AdbInputNumber from './base/adb-input-number';
import AdbInput from './base/adb-input';
import AdbSelect from './base/adb-select';
import AdbSwitch from './base/adb-switch';
import AdbTabs from './base/adb-tabs';

import { DayjsPlugin } from './directive';
import './theme/scss/shipber-ui.scss';
import * as units from '@adber/shipber-ui/utils/index.ts';

const components = [
  AdbFilterButtonItem,
  AdbFilterButtonGroup,
  AdbFilterOperation,
  AdbFilterDrawer,
  AdbFilterTag,
  AdbIcon,
  AdbButton,
  AdbDialog,
  AdbDraggable,
  AdbFormItem,
  AdbImage,
  AdbInputNumber,
  AdbInput,
  AdbSelect,
  AdbSwitch,
  AdbTabs,
];

// 加载adb-icon
(function () {
  const iconDom = document.getElementById('shipber-icon');

  if (!iconDom) {
    const d = document;
    const s = d.createElement('script');
    s.src = '//at.alicdn.com/t/font_2242249_3ei7l2rssre.js';
    s.id = 'shipber-icon';
    d.getElementsByTagName('head')[0].appendChild(s);
  }
})();

const install = function (Vue) {
  components.map((component) => Vue.component(component.name, component));
  Vue.use(DayjsPlugin);
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  version: '1.0.0',
  install,
  DayjsPlugin,
  units,
  AdbFilterButtonItem,
  AdbFilterButtonGroup,
  AdbIcon,
  AdbButton,
  AdbDialog,
  AdbDraggable,
  AdbFormItem,
  AdbImage,
  AdbInputNumber,
  AdbInput,
  AdbSelect,
  AdbSwitch,
  AdbTabs,
};
